import { render, staticRenderFns } from "./ImportContestant.vue?vue&type=template&id=bd5be9e6"
import script from "./ImportContestant.vue?vue&type=script&lang=js"
export * from "./ImportContestant.vue?vue&type=script&lang=js"
import style0 from "./ImportContestant.vue?vue&type=style&index=0&id=bd5be9e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports